/**
 * Segmentation d'affichage du menu par plateforme.
 *
 * Chaque item de `web_menu` peut porter un champ `platform` :
 *   "ALL" (défaut)   → visible sur le site web ET dans l'app mobile native
 *   "ONLY_DESKTOP"   → site web (navigateur) uniquement
 *   "ONLY_APPMOBILE" → app mobile native uniquement
 *
 * La surface courante se déduit du contexte de rendu : l'app native ouvre le site
 * dans une WebView et reçoit `context.mobileConfig` (greffé par l'API quand le
 * cookie `mobile=1` est présent). Donc :
 *   - `context.mobileConfig` présent  → on est dans l'APP   → on garde ALL + ONLY_APPMOBILE
 *   - `context.mobileConfig` absent   → on est en NAVIGATEUR → on garde ALL + ONLY_DESKTOP
 *
 * INVARIANT : un item sans `platform` (ou avec une valeur inconnue) est traité
 * comme "ALL" → tous les menus existants restent visibles partout (rétro-compatible,
 * navigateur strictement inchangé tant qu'aucun item n'est segmenté).
 *
 * On filtre le TABLEAU COMPLET (racines + enfants) en une passe : les composants
 * de menu reconstruisent l'arbre via `item.parent`, donc retirer un item parent
 * retire naturellement sa branche, et un enfant gardé sous un parent masqué
 * disparaît de toute façon (son parent n'est plus rendu).
 */

// Vrai si l'item doit s'afficher sur la surface courante (isApp = app native).
export function isItemVisibleOnPlatform(item, isApp) {
    const platform = item && item.platform;
    if (platform === "ONLY_DESKTOP") return !isApp;
    if (platform === "ONLY_APPMOBILE") return isApp;
    // "ALL", absent, ou valeur inconnue → partout.
    return true;
}

// Filtre un tableau d'items de menu selon le contexte de rendu.
// `context.mobileConfig` présent = app native ; absent = navigateur.
export function filterMenuByPlatform(items, context) {
    if (!Array.isArray(items)) return [];
    const isApp = !!(context && context.mobileConfig);
    return items.filter((item) => isItemVisibleOnPlatform(item, isApp));
}
